// src/App.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import ReportPage from './pages/ReportPage';
import LoginPage from './pages/LoginPage';
import PaymentPage from './pages/PaymentPage';
import PaymentResultPage from './pages/PaymentResultPage';
import InstallmentSelectionPage from './pages/InstallmentSelectionPage';
import PrivateRoute from './components/PrivateRoute';
import LogReportPage from './pages/LogReportPage';
import InstallmentChangePage from './pages/InstallmentChangePage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />

      {/* PrivateRoute ile sarmalanan tüm rotalar için giriş gereksinimi */}
      <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/home" element={<HomePage />} />
      
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/installment" element={<InstallmentSelectionPage />} />
          <Route path="/payment-result/:status" element={<PaymentResultPage />} />
          <Route path="/report" element={<ReportPage />} />
          
            {/* Sadece admin erişimi gerektiren rotalar örneği */}
      <Route element={<PrivateRoute requiredRole="admin" />}>
   
      <Route path="/installment-change" element={<InstallmentChangePage />} />
     
      <Route path="/log-report" element={<LogReportPage />} />
        </Route>
      </Route>

    
      </Route>

     
    </Routes>
  );
}

export default App;
